<template>
	<div class="all">
		<div class="container" ref="oneHeight">
			<p class="conentTitle">案例展示</p>
			<div class="conent">
				<div>
					<div class="titleCircular">市</div>
					<p>市级民政局客户</p>
					<ul>
						<li>南 京 市 民 政 局</li>
						<li class="toRight">西 宁 市 民 政 局</li>
						<li>泰 州 市 民 政 局</li>
						<li class="toRight">沈 阳 市 民 政 局</li>
						<li>绍 兴 市 民 政 局</li>
						<li class="toRight">九 江 市 民 政 局</li>
						<li>鞍 山 市 民 政 局</li>
						<li class="toRight">贵 阳 市 民 政 局</li>
						<li>景 德 镇 市 民 政 局</li>
					</ul>
				</div>
				<div>
					<div class="titleCircular">区</div>
					<p>区县(市)民政局客户</p>
					<ul>
						<li>高 淳 区 民 政 局</li>
						<li class="toRight">青 山 湖 区 民 政 局</li>
					</ul>
				</div>
			</div>
		</div>
		<div ref="twoHeight">
			<p class="conentTitle">项目分布</p>
			<my-cooper class="map-map"></my-cooper>
		</div>
	</div>
</template>

<script>
import myCooper from '@/page/home/cooperation.vue';
export default {
	components: {
		myCooper
	},
	data() {
		return {};
	},
	// mounted: function() {
	// 	window.addEventListener('scroll', this.handleScroll);
	// },
	mounted() {
		let ownOne = this.$refs.oneHeight.offsetHeight;
		let headAll = parseInt(window.sessionStorage.getItem('headHeight'));
		// if(this.$store.state.navIndex==2){
		// 	document.documentElement.scrollTop=ownOne+headAll
		// }
		this.$bus.$on('getCase', val => {
			if (val == 2) {
				document.documentElement.scrollTop = ownOne + headAll;
			}
		});
	},

	methods: {}
};
</script>

<style scoped="scoped">
.container {
	padding: 0 16%;
}
.all .conentTitle {
	text-align: center;
	font-size: 30px;
	padding: 40px 0;
	color: #666666;
}
.container .conent {
	display: flex;
	justify-content: space-between;
}
.container .conent > div {
	width: 47.5%;
	position: relative;
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 2px 8px rgba(188, 228, 249, 0.2), 0 2px 8px rgba(188, 228, 249, 0.4);
}
.titleCircular {
	color: #717171;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: -45px;
	width: 90px;
	height: 90px;
	line-height: 90px;
	text-align: center;
	font-size: 28px;
	border-radius: 50px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(188, 228, 249, 0.2), 0 2px 8px rgba(188, 228, 249, 0.4);
}
.container .conent > div > p {
	text-align: center;
	font-size: 24px;
	margin-top: 70px;
	color: #717171;
}
.container .conent > div > ul {
	padding: 16px 10% 140px 10%;
	font-size: 26px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	color: #717171;
}
.container .conent > div > ul > li {
	width: 50%;
	box-sizing: border-box;
	margin-bottom: 16px;
}
.container .conent > div > ul > li > a:hover {
	color: #7cc5f5;
	cursor: pointer;
}
.toRight {
	text-align: right;
}
.all .map-map {
	margin-bottom: 300px;
}
</style>
